import { Formik, Form } from "formik";
import Input from "../Input/Input";
import * as Yup from "yup";

const FormSchema = Yup.object().shape({
  description: Yup.string().required("Pole jest wymagane").trim(),
});

type Props = {
  handleSaveKind(data: any): void;
  handleClose(): void;
};

export const NewKindForm: React.FC<Props> = ({
  handleSaveKind,
  handleClose,
}) => {
  return (
    <Formik
      enableReinitialize={true}
      onSubmit={(values) => {
        handleSaveKind({
          description: values.description.trim(),
          active: true,
          dictNumber: 3,
          dictName: "slownik_rodzaju_kontroli",
        });
        handleClose();
      }}
      validationSchema={FormSchema}
      initialValues={{
        description: "",
      }}
    >
      {({ values, errors, touched, handleChange }) => {
        return (
          <Form>
            <Input
              type='text'
              name='description'
              inputId='n-kind-description'
              onChange={handleChange}
              label='Rodzaj kontroli'
              chartsCount={values.description.length}
              maxLength={500}
              formik={true}
              invalid={Boolean(errors.description && touched.description)}
              error={
                errors.description && touched.description
                  ? errors.description
                  : undefined
              }
              errorId='n-kind-description-error'
            />
            <div className='btn_group'>
              <button
                className='btn save-btn'
                id='save_button'
                type='submit'
              >
                ZAPISZ
              </button>
              <button
                className='btn cancel-btn'
                type='button'
                onClick={() => handleClose()}
              >
                ANULUJ
              </button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
